import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import config from '../../config.js';

function RoleAssignmentDropDown({ roles, setRoles, setRolesForAssignment , rolesForAssignmentDisplay, setRolesForAssignmentDisplay}) {

    const [assignedRole, setAssignedRole] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const getRolesForAssignment = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${config.serviceUrl}/role/list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            });
            setRolesForAssignment(response.data.data);
            setRolesForAssignmentDisplay(response.data.data.filter(role => !roles.some(r => r.name === role.name)));

        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false);
        }
    }, [roles, setRolesForAssignment, setRolesForAssignmentDisplay]);

    useEffect(() => {
        getRolesForAssignment();
    }, [getRolesForAssignment])

    const handleAddRole = () => {
        if (assignedRole && !roles.some(r => r.name === assignedRole.name)) {
            setRoles([...roles, assignedRole]);
            setRolesForAssignmentDisplay(rolesForAssignmentDisplay.filter(r => r.name !== assignedRole.name));
            setAssignedRole(null);
        }
    }

    return (
        <div className="mt-3">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Assign Role</label>
            <div className="flex gap-3 mb-4">
                {
                    isLoading ?
                        <div className="flex justify-center items-center">
                            <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                        :
                        <div className="relative flex-1">
                            <button 
                                className="w-full px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors flex justify-between items-center"
                                type="button" 
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            >
                                <span>{assignedRole ? assignedRole.label : "Select Role"}</span>
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {isDropdownOpen && (
                                <div className="absolute left-0 right-0 mt-2 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-slate-700 z-50 max-h-60 overflow-y-auto">
                                    {rolesForAssignmentDisplay.length > 0 ? (
                                        rolesForAssignmentDisplay.map((role, index) => (
                                            <button
                                                key={index}
                                                className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors text-gray-900 dark:text-white first:rounded-t-lg last:rounded-b-lg"
                                                onClick={() => { 
                                                    setAssignedRole(role);
                                                    setIsDropdownOpen(false);
                                                }}
                                            >
                                                {role.label}
                                            </button>
                                        ))
                                    ) : (
                                        <div className="px-4 py-2 text-gray-500 dark:text-gray-400">No roles available</div>
                                    )}
                                </div>
                            )}
                        </div>
                }
                <button
                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={isLoading || !assignedRole}
                    onClick={handleAddRole}
                >
                    Add
                </button>
            </div>
        </div>
    )
}

export default RoleAssignmentDropDown;
